// ─────────────────────────────────────────────────────────────────────────────
// SortBeat Daily — Theme Names
// Canonical pool shared between the client (offline fallback) and the Edge
// Function (generate-daily-seed). The djb2 hash function is identical in both
// so any date string always resolves to the same theme name, online or offline.
//
// Backend Engineer: to add new themes, append to THEME_NAMES (never reorder or
// remove existing entries — that would shift all existing theme assignments).
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Canonical ordered theme name pool.
 * First 20 entries match the deployed Edge Function v1 — order is frozen.
 * Append new themes below the "─── Expansion" divider only.
 */
export const THEME_NAMES: readonly string[] = [
  // ── Foundation (matches Edge Function v1 — DO NOT reorder) ──────────────
  'Auckland Rush',
  'NZ Kiwi Drop',
  'Harbour Bridge',
  'Volcanic Surge',
  'Midnight Cascade',
  'Neon Monsoon',
  'Solar Drift',
  'Deep Current',
  'Ember Storm',
  'Crystal Rhythm',
  'Urban Pulse',
  'Sunset Tide',
  'Arctic Beat',
  'Desert Wind',
  'Jungle Flow',
  'Techno Rain',
  'Sakura Fall',
  'Northern Lights',
  'Coral Tempo',
  'Shadow Dance',

  // ── Expansion ────────────────────────────────────────────────────────────
  'Prism Shift',
  'Electric Tide',
  'Copper Storm',
  'Indigo Rush',
  'Velvet Drop',
  'Monsoon Break',
  'Iron Cascade',
  'Radiant Flow',
  'Cobalt Surge',
  'Amber Wave',
  'Neon Cascade',
  'Frost Rhythm',
  'Thunderwave',
  'Pacific Rush',
  'Crimson Drift',
  'Obsidian Beat',
  'Lotus Fall',
  'Turquoise Tide',
  'Wildfire Pulse',
  'Marble Storm',
  'Starfall Tempo',
  'Quicksilver',
  'Aurora Wave',
  'Citrus Drop',
  'Carbon Rush',
  'Phantom Surge',
  'Velvet Storm',
  'Glacier Beat',
  'Saffron Cascade',
  'Dusk Protocol',
  'Opal Flow',
  'Bronze Rhythm',
  'Nebula Drop',
  'Foxglove Rush',
  'Titanium Wave',
  'Sunrise Grid',
  'Tidal Lock',
  'Solstice Beat',
  'Cinder Pulse',
  'Lunar Cascade',
];

/**
 * Deterministic theme picker — identical algorithm to the Edge Function.
 * djb2 hash of the date string, modulo pool length.
 *
 * Given the same dateString this will ALWAYS return the same theme name,
 * whether the app is online (Supabase row) or offline (this fallback).
 *
 * @param dateString  ISO date string e.g. "2026-06-29"
 */
export function pickTheme(dateString: string): string {
  let hash = 5381;
  for (let i = 0; i < dateString.length; i++) {
    hash = ((hash * 33) ^ dateString.charCodeAt(i)) >>> 0;
  }
  return THEME_NAMES[hash % THEME_NAMES.length] ?? 'Daily Challenge';
}
